export var ErrorCode;
(function (ErrorCode) {
    ErrorCode["Empty"] = "";
    ErrorCode["InvalidClientDate"] = "InvalidClientDate";
})(ErrorCode || (ErrorCode = {}));
